import React from 'react';
import { NavigationProps } from './props.types';
import classNames from 'classnames';
import * as styles from './navigation.module.sass';

export const Navigation = (props: NavigationProps) => {

  return (
    <li className={classNames(
      { [styles.nav_item]: !props.nav_link },
      props.liClassName,
      { [styles.active]: props.active })}>
      <a
        href={props.href}
        className={classNames({ [styles.nav_link]: props.nav_link })}
      >
        {props.title}
      </a>
    </li>
  );
};
